import { useMutation } from '@tanstack/react-query';

import { MembershipIdentifierFormSchemaValues } from 'src/features/membershipType/formSchema';
import { MembershipIdentifier } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership/:membershipId/identifiers/`;

interface DTO extends MembershipIdentifierFormSchemaValues {
    parkingId: string;
    membershipId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipId, ...data }: DTO): Promise<MembershipIdentifier> => {
    return axios.post(formatResourcePath(RESOURCE, { membershipId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateIdentifier };
